module.exports = __webpack_public_path__ + "static/media/education-object-4-0-0.68e821b9.png";